import { Button } from '@chakra-ui/react'
import React, { type ReactNode } from 'react'
import clsx from 'clsx'
import { useApplyV2Context } from '@core/utils/contexts/ApplyV2ModalContext/ApplyV2ModalContext'
import useLocalStorageStore from '@core/utils/hooks/useLocalStorageStore'
import './ApplyDialogV2.scss'

const baseClass = 'ApplyDialogV2'

interface ApplyDialogV2Props {
    className?: string
    children?: ReactNode
}

function ApplyDialogV2({ className = '', children }: ApplyDialogV2Props) {
    const { onOpenApply, isExpanded, isOpen, onCloseApply, onResizeApply } = useApplyV2Context()

    if (!isOpen) return null

    return (
        <div
            className={clsx(baseClass, {
                [`${baseClass}__expanded`]: isExpanded,
                [`${baseClass}__opened`]: isOpen,
                [className]: !!className,
            })}
        >
            <div className="ApplyDialogV2__header">
                <Button size="sm" onClick={onResizeApply}>
                    {isExpanded ? 'Collapse' : 'Expand'}
                </Button>
                <Button size="sm" onClick={onCloseApply}>
                    Close
                </Button>
            </div>
            <div className="ApplyDialogV2__content">dddd</div>
        </div>
    )
}

export default ApplyDialogV2
